import { Body, Box, Button, Image } from '@hover/blueprint';
import { iPlus } from '@hover/icons';
import React from 'react';

import { BasicCard } from 'src/modules/homeownerApp/components/Card/Card';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface NewProjectCTAProps {
  image: string;
}

const NewProjectCTA = ({ image }: NewProjectCTAProps) => {
  const { setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  return (
    <Box marginX={{ base: 200, tablet: 400 }} marginY={700}>
      <BasicCard hasShadow padding={400} sx={{ textAlign: 'center' }}>
        <Image
          alt="new-project-cta-image"
          borderRadius="8px"
          height="120px"
          marginX="auto"
          src={image}
          width="120px"
        />
        <Body isBold>{t('customize.addToProject.newProject.header')}</Body>
        <Body color="neutral.600" mb={400} mt={0}>
          {t('customize.addToProject.newProject.description')}
        </Body>
        <Button
          iconAfter={iPlus}
          onClick={() => setCurrentMenu(HomeownerAppMenuNames.NEW_PROJECT)}
          width="100%"
        >
          {t('customize.addToProject.newProject.newProject')}
        </Button>
      </BasicCard>
    </Box>
  );
};

export { NewProjectCTA };
